<span class="p-0 d-flex flex-column align-content-center">
  <span class="title">
      <strong class="capitalize"><i class="icon icon-pthemes">&nbsp;</i> {{item.title | lowercase}}</strong>
  </span>
  <span class="p-0 subtitle">
      <i class=" icon icon-multiple-users-silhouette" aria-hidden="true"></i>
      {{item.paxAdults}} Adults | 
      <i class="icon icon-menor" aria-hidden="true"></i>
      {{item.paxChild}} Children
  </span>
  <span class="p-0 description capitalize">
    <p class="pt-1">{{item.name | lowercase}}</p>
  </span>
</span>